module.exports = __webpack_public_path__ + "static/logo-9a8b9d1c1fc732b22f98c88fef356a9c.svg";